import {mapGetters} from "vuex";

<template>
    <div>
        <compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData" :col="1"></compFormEdit>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{$t('global.common.update_OK', { defaultValue: '确定'})}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
        </div>
        <vLoading loading fix v-if="loading"></vLoading>
    </div>
</template>

<script>

import { HttpOtherLogiServiceList, HttpGetCarrierGroupByOrg,} from "@/service/carrieraccount";
import {  HttpCopyAddonRule, HttpGetServiceList, HttpGetServiceProductList } from "@/service/fedex";
import { HttpProductList } from '@mods/service/dictionary';
import {mapGetters} from 'vuex';
import mixin from '../mixin'

export default {
    props:[],
    data(){
        return {
            formData:{
                sourceRegionCode: '',
                targetRegionCode: '',
            },
            groupList:[],
            groupServiceList:[],
            showaccount:false,
            loading:false,
            showCapacity:false,
            sourproductList:[],
            tarproductList:[],

        }
    },
    created(){
    },
    computed:{
        ...mapGetters('dictionary',['getNextOrgList','getCountryList']),
        getBase(){
            return [
                {
                    label: this.$t('fbb.carrier.extra_source', { defaultValue: '来源组织' }),
                    tag: 'vSelect',
                    key: "sourceOrgId",
                    span: 24,
                    props: {
                        filterable: true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(val){
                                // this.getOrgGroupList(val);
                                this.getProduct(val)
                                HttpGetServiceList({
                                // HttpGetCarrierGroupByOrg({
                                    // contextId:global.SYSID,
                                    customerId: val,
                                }).then(
                                    (res) => {
                                        this.groupList = res.data.map(item => {
                                            return {
                                                value: item.id,
                                                label: item.carrierGroupCode,
                                                attach: {
                                                    ...item
                                                },
                                            };
                                        });
                                    },
                                    (err) => {
                                        this.$VMessage.error(err.message);
                                    }
                                );
                            }

                        }
                    },
                    options: this.getNextOrgList
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: '物流产品',
                    key: "sourceGroupId",
                    tag: 'Select',
                    options:this.groupList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(val)
                            // this.getGroupServiceList(val);
                            HttpGetServiceProductList({
                            // HttpOtherLogiServiceList({
                                contextId:global.SYSID,
                                carrierGroupId: val,
                                orgId: this.formData.sourceOrgId,
                            }).then(
                                (res) => {
                                    this.groupServiceList = res.data.map(item => {
                                        return {
                                            value: item.id,
                                            label: item.code,
                                            attach: {
                                                ...item
                                            },
                                        };
                                    });
                                    this.getSourceRegionCountry(val)
                                    this.getTargetRegionCountry(val)
                                },
                                (err) => {
                                    this.$VMessage.error(err.message);
                                }
                            );
                        }
                    },
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "sourceServiceId",
                    tag: 'Select',
                    options:this.groupServiceList,
                    props:{
                        filterable:true
                    },
                    // on: {
                    //     'on-change': (val)=>{
                    //         this.getSourceRegionCountry(val)
                    //     }
                    // },
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    tag: "div",
                    children: (h) => {
                        const region=this.getCountryList.filter(item=>item.value===this.formData.sourceRegionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t('fbb.account.sourceLineId', { defaultValue: '来源项目' }),
                    key: "sourceLineId",
                    tag:'Select',
                    options:this.sourproductList.map(item =>{
                        return {
                            label:item.name,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true
                    },
                    required:false
                },
                {
                    label: this.$t('fbb.carrier.extra_target_org', { defaultValue: '目标组织' }),
                    tag: 'vSelect',
                    key: "targetOrgIdList",
                    span: 24,
                    props: {
                        filterable: true
                    },
                    options: this.getNextOrgList,
                    on:{
                        'on-change':(val)=>{
                            this.targeProduct(val)
                        }
                    }
                },
                {
                    label:'目标物流产品服务',
                    tag: 'Select',
                    key: "targetServiceId",
                    span: 24,
                    props: {
                        filterable: true
                    },
                    options: this.groupServiceList,
                    // on: {
                    //     'on-change': (val)=>{
                    //         this.getTargetRegionCountry(val)
                    //     }
                    // },
                },
                {
                    label: this.$t('', { defaultValue: '目标国家' }),
                    tag: "div",
                    children: (h) => {
                        const region=this.getCountryList.filter(item=>item.value===this.formData.targetRegionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t('fbb.account.targetLineId', { defaultValue: '目标项目' }),
                    key: "targetLineIdList",
                    tag:'Select',
                    options:this.tarproductList.map(item =>{
                        return {
                            label:item.name,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true,
                        multiple:true,
                    },
                    required:false
                },
                {
                    query: true,
                    formItem: {
                        labelWidth: 60
                    },
                    span: 24,
                    valueText: '<div class="color-error">'+this.$t('fbb.carrier.extra_sure_copy', { defaultValue: '确认复制后，目标组织对应承运商服务原附加规则会被清除，请谨慎操作!' })+'</div>'
                },
            ]
        }
    },
    methods:{
        getProduct(val){
            HttpProductList({
                contextId:val
            }).then(res=>{
                // console.log(res.data)
                this.sourproductList = res.data
            })
        },
        getSourceRegionCountry(val){
            const groupService=this.groupList.filter(item=>{
                return item.value==val
            })
            this.formData.sourceRegionCode=groupService[0].attach.regionCode
        },
        getTargetRegionCountry(val){
            const groupService=this.groupList.filter(item=>{
                return item.value==val
            })
            this.formData.targetRegionCode=groupService[0].attach.regionCode
        },
        targeProduct(val){
            HttpProductList({
                contextId:val
            }).then(res=>{
                this.tarproductList = res.data
            })

        },
        async submit(){
            const valid = await this.$refs.formbase.validate();
            if (!valid) return;
            this.loading = true
            HttpCopyAddonRule({
                ...this.formData
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.loading = false
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message)
                this.loading = false
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    },
}
</script>
